import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { PersonVisualMock } from "./PersonVisualMock";

interface HumanizedVisualPanelProps {
  headline?: string;
  subheadline?: string;
}

export function HumanizedVisualPanel({
  headline = "O ecossistema definitivo para escalar VSLs.",
  subheadline = translateInterfaceText("Teste A/B, métricas avançadas, funil interativo, captura de leads e proteção anti-bloqueio, tudo em um só lugar.")
}: HumanizedVisualPanelProps) {
  useLanguage();
  return (
    <div className="relative h-full w-full flex items-center justify-center p-8 xl:p-16">
      <div className="relative z-10 w-full max-w-2xl">
        {/* Headline com animação de entrada */}
        <div className="text-center mb-10">
          <h1 className="text-[32px] lg:text-[40px] xl:text-[48px] text-white font-extrabold leading-[1.1] mb-5">
            {translateInterfaceText("O ecossistema definitivo")}<br className="hidden xl:block" /> {" "}{translateInterfaceText("para escalar VSLs.")}</h1>
          <p className="text-[14px] lg:text-[15px] xl:text-[16px] text-white/90 font-normal leading-[1.5] max-w-lg mx-auto">
            {subheadline}
          </p>
        </div>

        {/* Visual com pessoa */}
        <PersonVisualMock />

        {/* Tagline abaixo da imagem - DESTACADO */}
        <p className="text-center text-sm lg:text-base xl:text-lg text-white/80 font-medium mt-6">
          {translateInterfaceText("A Host VSL Transforma Recursos em Resultados")}</p>
      </div>
    </div>
  );
}
